import { fetchApi } from "../utils/fetchApi";

export function fetchNetload({ filter = {}, options = {} }) {
  return fetchApi({ url: 'netload', filter, options });
}

